import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';

export class Child {
    id: number;
    profileCreatedBy: string;
    name: string;
    gender: string;
    dateOfBirth: Date;
    dateOfBirthStr: string;
    country: string;
    phone: string;
    premium: string;
    scopePremium: string;
    webDomain: string;
    doctorName: string;
    referralName: string;
    parentName: string;
    parentEmail: string;
    parentPhone: string;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;
    birthDay: number;
    birthMonth: number;
    birthYear: number;
    ageWeeks: any;
    noOfDays: any;
    noOfMonths: any;
    ageYear: number;
    ageMonth: number;
    ageDays: number;

    static populate(jsonObject: any): Child {
        const obj = new Child();
        obj.id = jsonObject.id;
        obj.profileCreatedBy = jsonObject.profileCreatedBy;
        obj.name = jsonObject.name;
        obj.gender = jsonObject.gender;
        obj.dateOfBirth = jsonObject.dateOfBirth;
        obj.dateOfBirthStr = jsonObject.dateOfBirthStr;
        obj.country = jsonObject.country;
        obj.phone = jsonObject.phone;
        obj.premium = jsonObject.premium;
        obj.scopePremium = jsonObject.scopePremium;
        obj.webDomain = jsonObject.webDomain;
        obj.doctorName = jsonObject.doctorName;
        obj.referralName = jsonObject.referralName;
        obj.parentName = jsonObject.parentName;
        obj.parentEmail = jsonObject.parentEmail;
        obj.parentPhone = jsonObject.parentPhone;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        // Age Calculator
        obj.birthDay = jsonObject.birthDay;
        obj.birthMonth = jsonObject.birthMonth;
        obj.birthYear = jsonObject.birthYear;
        obj.ageWeeks = jsonObject.ageWeeks;
        obj.noOfDays = jsonObject.noOfDays;
        obj.noOfMonths = jsonObject.noOfMonths;
        obj.ageYear = jsonObject.ageYear;
        obj.ageMonth = jsonObject.ageMonth;
        obj.ageDays = jsonObject.ageDays;
        return obj;
    }

    static formPopulate(obj: Child, jsonObject: any): Child {
        if (obj == null) {
            obj = new Child();
        }
        obj.id = jsonObject.id;
        obj.profileCreatedBy = jsonObject.profileCreatedBy;
        obj.name = jsonObject.name;
        obj.gender = jsonObject.gender;
        obj.dateOfBirth = jsonObject.dateOfBirth;
        obj.dateOfBirthStr = jsonObject.day + '/' + jsonObject.month + '/' + jsonObject.year;
        obj.country = jsonObject.country;
        obj.phone = jsonObject.phone;
        obj.doctorName = jsonObject.doctorName;
        obj.referralName = jsonObject.referralName;
        obj.parentName = jsonObject.parentName;
        obj.parentEmail = jsonObject.parentEmail;
        obj.parentPhone = jsonObject.parentPhone;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): Child {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = Child.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): Child [] {
        const lst: Child [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(Child.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
